<template>
  <div class="modal-mask" @mousedown.self.stop="closeModal()">
    <div class="modal dialog-pinned" @click.stop>
      <div class="modal__head">
        <div class="modal__title">
          <span class="pinned__icon">
            <svg width="13" height="14" viewBox="0 0 13 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M7.27562 5.39689L5.60838 3.37356L6.25941 2.92648C6.46386 2.78607 6.49527 2.47665 6.32956 2.23535L5.72949 1.36156C5.56378 1.12027 5.26372 1.03849 5.05926 1.17889L0.863777 4.06013C0.659324 4.20053 0.627915 4.50995 0.793622 4.75125L1.39369 5.62504C1.5594 5.86633 1.85947 5.94811 2.06392 5.80771L2.71495 5.36062L4.00474 7.64315C3.53848 8.56753 3.46617 9.70057 4.10049 10.6242C4.26619 10.8655 4.56626 10.9473 4.77071 10.8069L6.86846 9.36628L8.1687 11.2596C8.18423 11.2822 8.204 11.3015 8.22646 11.3158L9.19672 11.9354C9.31562 12.0113 9.44568 11.9223 9.41747 11.7838L9.18759 10.6558C9.18226 10.6296 9.17141 10.6043 9.15589 10.5817L7.85565 8.68833L9.95339 7.24771C10.1578 7.10731 10.1893 6.79789 10.0235 6.55659C9.38367 5.62487 8.29479 5.29473 7.27562 5.39689Z" fill="currentColor"/>
            </svg>
          </span>
          Закрепленное сообщение
        </div>
        <div class="close" @click.stop="closeModal()">
          <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 1L16 16" stroke="currentColor" stroke-width="2"/>
            <path d="M1 16L16 1" stroke="currentColor" stroke-width="2"/>
          </svg>
        </div>
      </div>
      <div class="modal__body">
        <div class="dialog-pinned__message custom-scrollbar">
          <span class="plain-html" v-html="state.message"></span>
        </div>
        <div class="dialog-pinned__attachments custom-scrollbar"
             v-if="state.attachments && state.attachments.length !== 0"
        >
          <AppMessageAttachmentPreview :files="state.attachments"
                                       clickable
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import AppMessageAttachmentPreview from '@/components/page/input/AppMessageAttachmentPreview'
export default {
  name: 'dialog-pinned-modal',
  components: { AppMessageAttachmentPreview },
  props: {
    state: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    currentUser () {
      return this.$store.getters.currentUser
    }
  },
  methods: {
    closeModal () {
      this.$emit('close-modal')
    }
  },
  mounted () {}
}
</script>

<style lang="scss" scoped>
@import '../../../assets/css/system/_vars';
@import '../../../assets/css/system/_mixins';

.modal-mask {
  position: absolute;
  display: block;
  top: 0;
  right: 0;
  left: 0;
  background: rgba(255, 255, 255, 0.6);
}

.modal {
  position: absolute;
  top: 5%;
  bottom: 10%;
  left: 5%;
  right: 5%;
  width: 90%;
  max-width: 640px;
  margin: 0 auto;
  padding-bottom: 20px;

  @media screen and (max-width: $tablet_start) {
    top: 0;
    left: 0;
    right: 0;
    bottom: auto;
    margin: 0;
    width: 100%;
    min-height: 50vh;
  }

  &__head {
    background: $color_sixth;
    padding: 12px 0 12px 20px;
    margin-bottom: 20px;

    &:before {
      display: none;
    }
  }

  &__title {
    color: #C01082;
    font-size: 16px;
  }

  &__body {
    width: 100%;
    height: 100%;
    display: flex;
    flex-flow: column;
    overflow: auto;
    padding-right: 20px;
  }

  .close {
    color: $color_deactive-second;

    &:hover {
      color: $color_second-light;
    }
  }
}

.dialog-pinned {
  color: $font_color_second;

  &__message {
  }

  &__attachments {
    margin-top: 20px;
  }
}
</style>
